import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';


/**
 * Groupings
 */

const fetchUnitSummaryReport = async () => {
    const { data } = await api.get('/unit-summary-report');

    return data;
};


export const useUnitSummaryReport = queryOptions => useQuery('unitSummaryReport', fetchUnitSummaryReport, queryOptions);


export const clearGetPricing2Cache = async id => {

    const { data } = await api.post(`/refreshCacheGetPricing2/${id}`);

    return data;
};

const createUnitTypeGrouping = async payload => {
    const { data } = await api.post('/unit-type-groupings', payload);

    return data;
};

export const useCreateUnitTypeGrouping = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createUnitTypeGrouping(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
            queryClient.invalidateQueries('unitSummaryReport');
        },
        ...queryOptions
    });
};

const deleteUnitTypeGrouping = async id => {
    const { data } = await api.delete(`/unit-type-groupings/${id}`);

    return data;
};

export const useDeleteUnitTypeGrouping = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => deleteUnitTypeGrouping(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
        },
        ...queryOptions
    });
};

const fetchAvailableUnitTypes = async (property_id, type) => {
    const { data } = await api.get(`/properties/${property_id}/${type}/available`);

    return data;
};

export const useAvailableUnitTypes = (property_id, type, queryOptions) => useQuery(['availableUnitTypes', property_id], () => fetchAvailableUnitTypes(property_id, type), queryOptions);


const fetchGroupings = async () => {
    const { data } = await api.get('/groupings');

    return data;
};

export const useGroupings = (queryOptions = {}) => useQuery('unitGroupings', fetchGroupings, queryOptions);

/*
* SPECIALS
*/


const createSpecial = async payload => {
    const { data } = await api.post('/special-groupings', payload);

    return data;
};

const deleteSpecial = async id => {
    const { data } = await api.delete(`/special-groupings/${id}`);

    return data;
};

const fetchAvailableSpecialGroupings = async propertyId => {
    const { data } = await api.get(`/properties/${propertyId}/specials/available`);

    return data;
};


export const useAvailableSpecialGroupings = (propertyId, queryOptions = {}) => useQuery(['availableSpecialGroupings', propertyId], () => fetchAvailableSpecialGroupings(propertyId), {
    cacheTime: 0,
    ...queryOptions
});

export const useCreateSpecial = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createSpecial(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
        },
        ...queryOptions
    });
};

export const useDeleteSpecial = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(id => deleteSpecial(id), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
            queryClient.invalidateQueries('availableSpecialGroupings');
        },
        ...queryOptions
    });
};


/*
* GROWTH RATES
*/


const createGR = async payload => {
    const { data } = await api.post('/growth-rates', payload);

    return data;
};

const deleteGR = async id => {
    const { data } = await api.delete(`/growth-rates/${id}`);

    return data;
};

const fetchAvailableGRGroupings = async propertyId => {
    const { data } = await api.get(`/properties/${propertyId}/growth-rates/available`);

    return data;
};


export const useAvailableGRGroupings = (propertyId, queryOptions = {}) => useQuery(['availableGRGroupings', propertyId], () => fetchAvailableGRGroupings(propertyId), {
    cacheTime: 0,
    ...queryOptions
});

export const useCreateGR = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createGR(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
        },
        ...queryOptions
    });
};

export const useDeleteGR = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(id => deleteGR(id), {
        onSuccess: () => {
            queryClient.invalidateQueries('unitGroupings');
            queryClient.invalidateQueries('availableGroupings');
        },
        ...queryOptions
    });
};
